module.exports = __webpack_public_path__ + "static/media/V38Logo.2d8d72cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/V38Logo.svg
// module id = 46
// module chunks = 0